import { Reducer } from "redux";
import { getDealSuccess } from "src/store/actions/deal";
import { pollingSuccess } from "src/store/actions/poller";
import { DealerOffer } from "Types/api/DealerOffer";
import { ApiVehicle } from "Types/api/Vehicle";

type DealerOfferActions = ReturnType<typeof pollingSuccess> | ReturnType<typeof getDealSuccess>;

export interface DealerOfferByVin {
    [vin: string]: DealerOffer;
}

const dealerOffer: Reducer<DealerOfferByVin, DealerOfferActions> = (state = {}, action) => {
    switch (action.type) {
        case pollingSuccess.type:
        case getDealSuccess.type:
            return getNewStateFromVehicles(state, action.payload.deal.vehicles as ApiVehicle[]);
        default:
            return state;
    }
};

const getNewStateFromVehicles = (state: DealerOfferByVin, vehicles: ApiVehicle[]): DealerOfferByVin => {
    return (vehicles || []).reduce((acc, curr) => {
        if (curr?.payments?.dealer) {
            acc[curr.vin] = curr?.payments?.dealer;
        }
        return acc;
    }, {});
};

export default dealerOffer;
